import TableGridWithFilters from '../components/tableComponents/TableGridWithFilters';
import React, { useState, useEffect } from 'react';
import { detailsColumns } from '../components/moneyCatalogDetails/detailsColumns';
import { moneyCatalogDetailsFilters } from '../components/moneyCatalogDetails/moneyCatalogDetailsFilters';
import DownloadButton from '../components/downloadButton';
import { useAuthContext } from '../context/AuthContext';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const MoneyCatalogDetails = () => {
  const { loading, setLoading } = useAuthContext();
  const [selectOptionsYear, setSelectOptionsYear] = useState([]);
  const [filtersValues, setFiltersValues] = useState([]);
  const { moneyCatalogId } = useParams();

  useEffect(() => {
    const getFilterArrays = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/getListOfYears`,
          {
            withCredentials: true,
          },
        );

        const _dataYears = response.data.years?.map((year) => ({
          key: year,
          value: year,
        }));

        setSelectOptionsYear(_dataYears);
      } catch (error) {
        console.error('Error fetching years:', error);
      } finally {
        setLoading(false);
      }
    };

    getFilterArrays();
  }, [setLoading]);

  return (
    <>
      <section className='app-container'>
        <div
          style={{
            marginBottom: 5,
            margin: '0 auto',
            width: '85vw',
            paddingBottom: '3em',
          }}
        >
          <h2>Προβολή Λεπτομερειών Χρηματικού Καταλόγου</h2>
          <TableGridWithFilters
            columns={detailsColumns}
            initialValues={{ year: '', status: '' }}
            filterFields={moneyCatalogDetailsFilters({ selectOptionsYear })}
            paginationMode='server'
            fetchUrl={`${process.env.REACT_APP_BACKEND_URL}/TotalDataMoneyCatalogDetails?money_catalog_id=${moneyCatalogId}`}
            style={{ width: '100%', flex: 1 }}
            onFiltersChange={(filters) => {
              setFiltersValues(filters);
            }}
          />
          <DownloadButton
            downloadUrl={`${
              process.env.REACT_APP_BACKEND_URL
            }/downloadMoneyCatalogDetails?${
              filtersValues.year
                ? `year=${filtersValues.year}&`
                : ''
            }${filtersValues.status
              ? `status=${filtersValues.status}&`
              : ''}${
              moneyCatalogId
                ? `&money_catalog_id=${moneyCatalogId}`
                : ''
            }`}
            filename='Λίστα'
            buttonText='Λήψη Αρχείου'
            disabled={loading}
          />
        </div>
      </section>
    </>
  );
};

export default MoneyCatalogDetails;
